import type { SVGProps } from 'react';

export default function ArrowDropDownIcon({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M8 11.14L2.4 5.54h11.2L8 11.14Z" />
    </svg>
  );
}
